module.exports = __webpack_public_path__ + "static/media/cherries-2402449_640-min.d4638bca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cherries-2402449_640-min.jpg
// module id = 143
// module chunks = 0